import useWaiterError from "../atoms/useWaiterError";
import useIsWaiter from "./useIsWaiter";

const useIsWaiterHook = () => {
  const isWaiter = useIsWaiter();
  const [error] = useWaiterError();
  const showError = isWaiter ? error !== null : false;
  return {
    isWaiter,
    showError,
    error,
  };
};

export default useIsWaiterHook;
